<template>

    <b-modal
        id="manage-tags-modal"
        title="Zarządzaj tagami"
        ok-only
        ok-title="Zamknij"
        ok-variant="secondary"
        no-close-on-backdrop
        size="xl"
        @hidden="manageTagsModalHandleHide">

        <div class="row">

            <div class="col-9">
                <div class="row">
                    <div class="col tag-category-players-age">
                        <div class="tag-column-heading">Wiek graczy</div>
                        <div v-for="tag in tags.players_age">
                            <div class="tag-element">
                                {{ tag.name }}
                                <a href="javascript:void(0);" title="Edytuj" @click="editTag(tag)"><i class="fa fa-pencil-square-o"></i></a>
                                <a href="javascript:void(0);" title="Usuń" @click="deleteTag(tag)"><i class="fa fa-trash"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col tag-category-number-of-players">
                        <div class="tag-column-heading">Ilość graczy</div>
                        <div v-for="tag in tags.number_of_players">
                            <div class="tag-element">
                                {{ tag.name }}
                                <a href="javascript:void(0);" title="Edytuj" @click="editTag(tag)"><i class="fa fa-pencil-square-o"></i></a>
                                <a href="javascript:void(0);" title="Usuń" @click="deleteTag(tag)"><i class="fa fa-trash"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col tag-category-operational-goals">
                        <div class="tag-column-heading">Cele operacyjne</div>
                        <div v-for="tag in tags.operational_goals">
                            <div class="tag-element">
                                {{ tag.name }}
                                <a href="javascript:void(0);" title="Edytuj" @click="editTag(tag)"><i class="fa fa-pencil-square-o"></i></a>
                                <a href="javascript:void(0);" title="Usuń" @click="deleteTag(tag)"><i class="fa fa-trash"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col tag-category-thematic-categories">
                        <div class="tag-column-heading">Kategorie tematyczne</div>
                        <div v-for="tag in tags.thematic_categories">
                            <div class="tag-element">
                                {{ tag.name }}
                                <a href="javascript:void(0);" title="Edytuj" @click="editTag(tag)"><i class="fa fa-pencil-square-o"></i></a>
                                <a href="javascript:void(0);" title="Usuń" @click="deleteTag(tag)"><i class="fa fa-trash"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-3">
                <div class="tag-form-heading">{{ formMode === 'add' ? 'Dodaj tag' : 'Edytuj tag' }}</div>
                <div class="form-group">
                    <label for="tag-category">Kategoria</label>
                    <select id="tag-category" class="form-control" v-model="form.category">
                        <option :value="null" selected disabled>wybierz...</option>
                        <option value="operational_goals">Cele operacyjne</option>
                        <option value="number_of_players">Ilość graczy</option>
                        <option value="thematic_categories">Kategorie tematyczne</option>
                        <option value="players_age">Wiek graczy</option>
                    </select>
                    <span class="error mt-2 text-danger" v-if="form.errors.has('category')" v-text="form.errors.get('category')"></span>
                </div>
                <div class="form-group">
                    <label for="tag-name">Nazwa</label>
                    <input type="text" id="tag-name" class="form-control" v-model="form.name" @input="validateTagNameCharInput($event)">
                    <small class="form-text text-muted">Domyślny język: <strong>PL</strong>.</small>
                    <span class="error mt-2 text-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
                </div>
                <button class="btn btn-success btn-sm pull-right" @click="submitTagForm">Zapisz</button>
            </div>

        </div>

    </b-modal>

</template>

<script>

    export default {

        name: 'ManageTagsChangelogModal',

        data() {
            return {
                eventHub: window.eventHub,
                tags: {
                    players_age: [],
                    number_of_players: [],
                    operational_goals: [],
                    thematic_categories: []
                },
                formMode: 'add',
                form: new Vue.prototype.Form({
                    id: null,
                    category: null,
                    name: null
                })
            }
        },

        mounted() {

            this.eventHub.$on('game-library-show-manage-tags-modal' , (type, element) => {
                this.eventHub.$emit('processing-start');

                axios.get(route('game::game-library.get-tags-grouped'))
                    .then(response => {
                        this.tags = response.data.data.tags;
                        this.sortTags();
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('manage-tags-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    });
            });

        },

        methods: {

            validateTagNameCharInput(event) {
                this.form.name = this.form.name.replace(/[,|]/g, '');
            },

            manageTagsModalHandleHide() {

            },

            sortTags() {
                let tagsOrderNumberOfPlayers = [
                    '1 gracz',
                    '2 graczy',
                    '4 graczy',
                    'Mała grupa (3-5 graczy)',
                    'Duża grupa (pow. 6 graczy)'
                ];
                this.tags.number_of_players.sort((tagA, tagB) => tagsOrderNumberOfPlayers.indexOf(tagA.name) - tagsOrderNumberOfPlayers.indexOf(tagB.name));

                let tagsOrderPlayersAge = [
                    '6 miesięcy',
                    '1 rok',
                    '2 lata',
                    '3 lata',
                    '4 lata',
                    '5 lat',
                    '6 lat',
                    '7 lat',
                    '8 lat',
                    '9 lat',
                    '10 lat',
                    '11 lat',
                    '12 lat',
                    '13 lat',
                    '14 lat',
                    '15 lat',
                    '16 lat',
                    '17 lat',
                    '18-65 lat',
                    '66-120 lat'
                ];
                this.tags.players_age.sort((tagA, tagB) => tagsOrderPlayersAge.indexOf(tagA.name) - tagsOrderPlayersAge.indexOf(tagB.name));
            },

            editTag(tag) {
                this.formMode = 'edit';
                this.form.id = tag.id;
                this.form.category = tag.category;
                this.form.name = tag.name;
            },

            deleteTag(tag) {
                this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć tag: ' + tag.name + '?', {
                    title: 'Usuń tag',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Usuń',
                    cancelTitle: 'Anuluj',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value) {
                            this.eventHub.$emit('processing-start');
                            axios.delete(route('game::game-library.delete-tag', {id: tag.id}))
                                .then(response => {
                                    this.tags = response.data.data.tags;
                                    this.sortTags();
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                                })
                                .catch(error => {
                                    console.log(error);
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                                });
                        }
                    });
            },

            submitTagForm() {
                this.eventHub.$emit('processing-start');
                if (this.formMode === 'add') {
                    this.form.post(route('game::game-library.store-tag'))
                        .then(response => {
                            this.tags = response.data.tags;
                            this.sortTags();
                            this.form.reset();
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                        });
                } else if (this.formMode === 'edit') {
                    this.form.put(route('game::game-library.update-tag', {id: this.form.id}))
                        .then(response => {
                            this.tags = response.data.tags;
                            this.sortTags();
                            this.form.reset();
                            this.formMode = 'add';
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                        });
                }

            }

        }

    }

</script>

<style>

    .tag-category-players-age .tag-element {
        background-color: #00a97f;
    }

    .tag-category-number-of-players .tag-element {
        background-color: #5151a6;
    }

    .tag-category-operational-goals .tag-element {
        background-color: #cd975a;
    }

    .tag-category-thematic-categories .tag-element {
        background-color: #cd5a77;
    }

    .tag-column-heading {
        font-weight: bolder;
        margin-bottom: 20px;
    }

    .tag-element {
        padding: 2px 5px;
        display: inline-block;
        margin-bottom: 10px;
        color: white;
        border-radius: 5px;
    }

    .tag-element a {
        color: white !important;
    }

    .tag-element a:first-child {
        margin-left: 10px;
    }

    .tag-element a:last-child {
        top: -1px;
        position: relative;
    }

    .tag-form-heading {
        font-weight: bolder;
        margin-bottom: 20px;
    }

</style>
